// 路由模式
export const ROUTING_MODE = 'HASH'
// 部署URL ##history模式必须配置
export const BASE_URL = './'

